module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Office-Desk.68fdb38b.jpg";